export function listenScrollTo() {
  const buttons = document.querySelectorAll('[data-href]');
  [...buttons].forEach((button) => {
    button.onclick = (e) => {
      const headerHeight = document.querySelector('.header-box').clientHeight;
      const link = e.currentTarget.dataset?.href;
      const y = document.querySelector(link).getBoundingClientRect().top
        + window.pageYOffset - headerHeight - 10;
      window.scrollTo({ top: y, behavior: 'smooth' });
      if (e.currentTarget.dataset.changeTab !== undefined) {
        $(e.currentTarget.dataset?.href).tab('show');
      }
    };
  });
}
